export default __webpack_public_path__ + "static/media/why-idn.d1e9dd90.png";